import hooks from './carrier.hooks';
import createSchema from './carrier.schema';

export default (app) => {
  const service = app.service('api/carrier');
  service.schema = createSchema(app);
  service.hooks(hooks);
};
